import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import RazorpayOverlay from "../Dashboard/ShoppingCart/Razorpay/RazorpayOverlay";
// import StripePopup from "../Dashboard/ShoppingCart/StripePopup";
import axiosInstance from "../../axios";

const EnterprisePayment = ({
  setPopUP,
  changedSelectedPlan,
  setStatusLoading,
  setDownGradeStatus,
}) => {
  const {
    loggedIn,
    geoLocation,
    isFetched = false,
  } = useSelector((state) => state.authentication);
  const { user } = useSelector((state) => state.users);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const isIND = geoLocation?.country_code === "IN" && isFetched;

  const testDemoPlan = localStorage.getItem("demo Plan");

  const getURL = () => {
    if (changedSelectedPlan && isIND) {
      return "/razorpay-checkout-url?testmode=on";
    }

    if (!changedSelectedPlan && isIND) {
      if (testDemoPlan === "Demo Plan") {
        return "/razorpay-checkout-url?testmode=on";
      } else {
        return "/razorpay-checkout-url";
      }
    }

    if (changedSelectedPlan) {
      return `/current-subscription?selectedPlan=${changedSelectedPlan}`;
    }

    return "/current-subscription";
  };

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      localStorage.removeItem("ck_session");

      if (loggedIn && isFetched) {
        try {
          const res = await axiosInstance.get(getURL());

          const sessionId = res?.data?.data?.id;
          const message = res?.data?.message;
          const data = res?.data?.data;

          localStorage.setItem(
            "ck_session",
            JSON.stringify({
              session: sessionId,
              country_code: geoLocation?.country_code,
              enterpriseStatus: true,
            })
          );

          if (message) {
            setDownGradeStatus(message);
          }

          setPaymentDetails(isIND ? data : data?.planInfo);
        } catch (error) {
          console.error("Error fetching payment details:", error.message);
        }
      }
    };

    fetchPaymentDetails();
  }, [isFetched]);


  const cartItems = [
    {
      SessionID: paymentDetails?.id,
      TotalAmount: paymentDetails?.amount,
      enterpriseStatus: true,
      changedSelectedPlan: changedSelectedPlan,
    },
  ];

  const popupCloseHandler = (e) => {
    setPaymentDetails((state) => !state);
    setPopUP((state) => !state);
  };
  const renderOverlay = (location) => {
    setStatusLoading(false);
    if ("IN" === location) {
      return <RazorpayOverlay onClose={popupCloseHandler} user={user} />;
    } else {
      return (
        // <StripePopup
        //   onClose={popupCloseHandler}
        //   cartItems={cartItems}
        // ></StripePopup>
        <></>
      );
    }
  };

  return <> {paymentDetails && renderOverlay(geoLocation?.country_code)}</>;
};
export default EnterprisePayment;
